import React from 'react'
import formStyles from 'modules/Forms/common-form.module.scss'
import styles from 'modules/Forms/Account/Create/account-form-creation.module.scss'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import { Button } from 'gu-ui-kit'
import PropTypes from 'prop-types'

const SubmitButtons = ({
  submitting = false,
  onClose = () => {},
  className = '',
  submitted = false,
}) => {
  const { t } = useTranslation()

  return (
    <div
      className={clsx(
        formStyles['formControl__action-buttons'],
        styles['action-buttons'],
        className,
      )}
    >
      {submitted ? (
        <Button
          fullWidth
          onClick={onClose}
          variant="primary"
          size="l"
          type="button"
        >
          {t('common::form_buttons.goToAccounts')}
        </Button>
      ) : (
        <>
          <Button
            disabled={submitting}
            onClick={onClose}
            variant={'ghost'}
            grey
            size="l"
            type="button"
            color={'Label-Fifth'}
          >
            {t('common::form_buttons.cancel')}
          </Button>

          <Button
            disabled={submitting}
            size="l"
            variant="primary"
            type="submit"
          >
            {t('services::forms.register_account.submit_button')}
          </Button>
        </>
      )}
    </div>
  )
}

SubmitButtons.propTypes = {
  submitting: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string,
  submitted: PropTypes.bool,
}

export default SubmitButtons
